import { checkParams, newArrayJustWithValues } from './../../components/Utils'
import { validateParamURL } from './../colors'

export const handleRangeSecondaryColor = async (ev, state, props) => {

  const { wizardPrimaryColors, primaryColorSelected } = state
  const { history, match, location } = props

  const secondaryColorParam = checkParams('secondary-color', location)
  const tertiaryColorParam = checkParams('tertiary-color', location)

  const colorsSecondaryData = wizardPrimaryColors && wizardPrimaryColors[primaryColorSelected] && wizardPrimaryColors[primaryColorSelected].wizard_colors_secondary_repeater

  let secondaryColorSelected = 1
  let colorsSecondary = newArrayJustWithValues(colorsSecondaryData, 'wizard_color_secondary_picker')


  if (colorsSecondaryData) {

    const sendTo = `/${match.params.wizardId}?primary-color=${primaryColorSelected}&secondary-color=${secondaryColorSelected}&step=1`

    const errorValueParam = validateParamURL(colorsSecondary, sendTo, history, secondaryColorParam)

    if (errorValueParam) {
      return {
        colorsSecondary,
        secondaryColorSelected 
      }
    }
  }


  if (ev) {
    secondaryColorSelected = parseInt(ev.target.value)
  }

  else if (secondaryColorParam) {
    secondaryColorSelected = parseInt(secondaryColorParam)
  }
  
  if (!tertiaryColorParam || ev) {    
    history.push(`/${match.params.wizardId}?primary-color=${primaryColorSelected}&secondary-color=${secondaryColorSelected}`)
  }


  return {
    colorsSecondary,
    secondaryColorSelected,
  }

}